import { apiClient } from "helpers/api_helper";

export const GetAllCustomOrderGrid = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/EstimatePayment/GetAllCustomOrderGrid`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetCustomOrderItemGridById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/EstimatePayment/GetAllCustomOrderItemGrid?customorderId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }

};
export const GetEstimatePyamentInvoice = async (receiptNo: string) => {
  try {
    const response = await apiClient.get(`/api/v1/SalesEntry/GetEstimatePyamentInvoice?receiptNo=${receiptNo}`);
    return response.data;
  } catch (error) {
    return { status: 500, message: "Failed to fetch invoice", error };
  }
};
